/**
 * Browse Page - Filmssavn
 * Browse all available content
 */

import { createFooter } from '../components/footer.js';
import { createNavigation } from '../components/navigation.js';
import { createVideoCard } from '../components/video-card.js';
import { api } from '../lib/api.js';
import { t } from '../lib/i18n.js';

export async function renderBrowse() {
  const app = document.getElementById('app');
  app.innerHTML = '';

  // Navigation
  app.appendChild(await createNavigation());

  // Page Header
  const header = document.createElement('section');
  header.className = 'section';
  header.style.paddingTop = '100px';
  header.innerHTML = `
    <div class="container">
      <div id="browse-grid" class="video-grid">
        <div class="loading-container">
          <div class="spinner"></div>
        </div>
      </div>
    </div>
  `;
  app.appendChild(header);

  let allVideos = [];

  // Get category from URL query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const currentFilter = urlParams.get('category') || 'documentary';

  // Load videos
  try {
    const data = await api.getVideos();
    allVideos = data.videos || [];

    // Apply filter based on URL parameter
    let filtered = allVideos;

    if (currentFilter === 'documentary') {
      filtered = allVideos.filter(
        (v) => v.category === 'documentary' || v.category === 'documentary_short' || v.category === 'documentary_long',
      );
    } else if (currentFilter === 'short') {
      filtered = allVideos.filter((v) => v.category === 'short');
    } else if (currentFilter === 'feature') {
      filtered = allVideos.filter((v) => v.category === 'feature');
    }

    renderVideos(filtered);
  } catch (error) {
    console.error('Failed to load videos:', error);
    document.getElementById('browse-grid').innerHTML =
      '<p class="text-center" style="color: var(--color-cloud-grey); grid-column: 1/-1;">Failed to load videos. Please try again later.</p>';
  }

  function renderVideos(videos) {
    const grid = document.getElementById('browse-grid');
    grid.innerHTML = '';

    if (videos.length > 0) {
      videos.forEach((video) => {
        grid.appendChild(createVideoCard(video));
      });
    } else {
      grid.innerHTML = `<p class="text-center" style="color: var(--color-cloud-grey); grid-column: 1/-1;">${t('no_videos')}</p>`;
    }
  }

  // Footer
  app.appendChild(createFooter());
}
